module.exports = __webpack_public_path__ + "static/media/KP.0601b8ad.png";